<div class="page" [ngClass]="setIntelDisplayOneFont ? 'intelOne-display':'latin-bold'">
  <!-- HERO -->
  <div class="hero" role="region" [ngClass]="{'ptl-wc-border': ptlType === 'PANTHER_LAKE', 'ptl-12xe-wc-border': ptlType === 'PANTHER_LAKE_12XE', 'ptl-gaming-wc-border': ptlType === 'PANTHER_LAKE_GAMING'
  }" aria-label="Welcome card" *ngIf="showVirtualAssistant">
    <!-- <div class="orb" aria-hidden="true"></div> -->
  
    <div class="title-wrap">
      <div class="title-heading">
         <img [src]="ptlVAHomePageText?.ptl_homePage_icon" class="home-page-gif" alt="animation" />
        <div class="home-page-wc-text" [ngClass]="ptlType=='PANTHER_LAKE' ? 'black-font' : 'white-font'">
          <h1 [innerHtml]="ptlVAHomePageText?.tr_VAHeading"></h1>
          <p [innerHtml]="ptlVAHomePageText?.tr_VASubHeading"></p>
        </div>
      </div>
  
      <div class="search-container">
        <input type="search" placeholder="{{ptlVAHomePageText?.tr_VAInputboxQuestion}}"
          aria-label="Ask me about this device" />
        <div class="search-send-img" [ngClass]="{'ptl12xe-search-icon': ptlType === 'PANTHER_LAKE_12XE','ptl-gaming-search-icon': ptlType === 'PANTHER_LAKE_GAMING','ptl-search-icon': ptlType === 'PANTHER_LAKE'}" (click)="routeToTab('va')">
          <img [src]="vaSearchSendIcon" alt="search icon"/>
        </div>
      </div>
    </div>
  </div>

  <div [innerHtml]="ptlHomePageText" class="hero-title" [ngClass]="[ptlType=='PANTHER_LAKE' ? 'black-font ptl-hero-title-padding' : 'white-font',setIntelDisplayOneFont ? 'intelOne-headline':'',showVirtualAssistant?'':'nova-hero-title', ptlType === 'PANTHER_LAKE_12XE' ? 'ptl12xe-heading-text' : '', !setIntelDisplayOneFont ? 'other-lang-font-style' : '', nonItalicLangArray.includes(language) ? 'non-italic-lang-cls':'']"></div>

  <div class="split-card" *ngIf="splitTile && gridTiles.length>=1" (click)="routeToTileDetailsPage(overviewLibraryContent[0]?.tileUrlName)"  [ngClass]="[ptlType=='PANTHER_LAKE' ? 'ptl-split-card-bg' : '', ptlType == 'PANTHER_LAKE_12XE' ? 'ptl12xe-split-card-bg' : '', ptlType === 'PANTHER_LAKE_GAMING' ? 'ptl-gaming-split-card' : '', isRTL ? 'rtlLang-alignment' : '']" role="article" aria-label="Feature">
    <div class="left" aria-hidden="true" style="background-image: url({{overviewLibraryContent[0]?.tileBadgeUrl}});"></div>
    <div class="right" [ngClass]="{'ptl-gaming-right-content': ptlType === 'PANTHER_LAKE_GAMING'}">
      <div *ngIf="ptlType === 'PANTHER_LAKE_GAMING'" [innerHtml]="splitTile?.tr_pretitle" class="ptl-gaming-pretitle">
    </div>
      <p [innerHtml]="overviewLibraryContent[0]?.tr_tileTitle" [ngClass]="[ptlType === 'PANTHER_LAKE_GAMING' ? splitTile?.tileUrlName + '_gaming_tileTitle_text' : splitTile?.tileUrlName + '_tileTitle_text', setIntelDisplayOneFont ? 'intelOne-display' : 'latin-bold', (isRTL && ptlType === 'PANTHER_LAKE_GAMING') ? 'rtlLang-ptl-gaming-alignment' : '']"></p>
    </div>
  </div>
 <!-- If grid is empty we needs to replace image and styling for single processor starts -->
  <div class="main-tile-area" *ngIf="splitTile && gridTiles.length===0"
    (click)="routeToTileDetailsPage(overviewLibraryContent[0]?.tileUrlName)"
    [ngClass]="[ptlType=='PANTHER_LAKE' ? 'ptl-main-tile-card-bg' : '', ptlType == 'PANTHER_LAKE_12XE' ? 'ptl12xe-main-tile-card-bg' : '', ptlType === 'PANTHER_LAKE_GAMING' ? 'ptl-gaming-main-tile-card' : '']"
    role="article" aria-label="Feature">
    <div class="main-tile-img" aria-hidden="true" style="background-image: url({{singleTileImagePath}});">
      <div [ngClass]="[ptlType === 'PANTHER_LAKE_GAMING'?'main-tile-text-div-gaming':'main-tile-text-div']">
        <div *ngIf="ptlType === 'PANTHER_LAKE_GAMING'" [innerHtml]="splitTile?.tr_pretitle" class="ptl-gaming-pretitle">
        </div>
        <p [innerHtml]="overviewLibraryContent[0]?.tr_tileTitle"
          [ngStyle]="{'color': ptlType=='PANTHER_LAKE'  ? '#262626' : '' }"
          [ngClass]="[ptlType === 'PANTHER_LAKE_GAMING' ? splitTile?.tileUrlName + '_gaming_tileTitle_text' : splitTile?.tileUrlName + '_tileTitle_text', setIntelDisplayOneFont ? 'intelOne-display' : 'latin-bold']">
        </p>
  
      </div>
    </div>
  
  </div>
  <!-- If grid is empty we needs to replace image and styling for single processor ends -->
  
  <div class="grid" role="list">
    <div *ngFor="let tile of gridTiles">
      <div *ngIf="tile?.tileUrlName !== 'ptl-evo'" (click)="routeToTileDetailsPage(tile.tileUrlName)" class="card-item card-yellow" role="listitem" [ngClass]="{
    'ai-experience-tile': tile?.tileUrlName === 'ptl-aiexperience', 'design-tile-border': tile.tileUrlName === 'ptl-design'}">
        <div class="tile-background-image" style="background-image: url({{tile?.tileBadgeUrl}});"></div>
        <div [innerHtml]="tile?.tr_pretitle" [ngClass]="[ptlType === 'PANTHER_LAKE_12XE'? tile?.tileUrlName + '_12xe_pretitile_class' : tile?.tileUrlName + '_pretitle_class', setIntelDisplayOneFont ? 'intelOne-headline' : '', !setIntelDisplayOneFont ? 'other-lang-font-style' : '', nonItalicLangArray.includes(language) ? 'non-italic-lang-cls':'']"></div>
        <p [innerHtml]="tile?.tr_tileTitle" class="tile-text" [ngClass]="[((ptlType=='PANTHER_LAKE' && (tile.tileUrlName == 'ptl-performance')) ? 'black-font' : 'white-font'), ptlType === 'PANTHER_LAKE_12XE' ? tile?.tileUrlName + '_12xe_tileTitle_text' : tile?.tileUrlName + '_tileTitle_text', isRTL ? 'rtlLang-alignment' : '']"></p>
      </div>
    </div>
  </div>
  <div class="legal-text" (click)="open(legalModal)" [ngClass]="[(ptlType === 'PANTHER_LAKE_12XE' || ptlType === 'PANTHER_LAKE_GAMING') ? 'XE_gaming_legal_text' : '',(!isScrollable)?'fixed-legal-text':'']">
     <span class="legal-text-decoration" [innerHTML]="legalText"></span>
    <span [innerHTML]="legalVersion"></span>
  </div>

</div>
<ng-template #legalModal let-modal tabindex="-1" role="dialog" aria-labelledby="legalTextModalLabel" aria-hidden="true">
    <div class="legal-modal-container" id="rtlDirection" [dir]="direction" [ngStyle]="{'text-align':(direction === 'rtl')? 'right' : ''}"
      [ngClass]="legalTextFontClass">
      <div id="modalHeaderLegalText" class="modal-header">
        <h2 class="modal-title" id="legalTextModalLabel" [class.intelOne-display]="setIntelDisplayOneFont"
          [innerHTML]="legalText"></h2>
        <button data-dismiss="modal" class="close" (click)="close()">
        <img src="assets/images/close_icon_legal_popup.svg"aria-hidden="true" class="close-icon" alt="close" />
      </button>
      </div>
      <div id="modalBodyLegalContent" class="modal-body" [class.intelOne-display]="setIntelDisplayOneFont">
        <p *ngFor='let value of legalContent' [innerHTML]="value">
        </p>
      </div>
    </div>
</ng-template>
